import { render } from "./PlanSidebar.vue?vue&type=template&id=a6ca10ae"
import script from "./PlanSidebar.vue?vue&type=script&lang=js"
export * from "./PlanSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__